import { useSelector } from 'react-redux';
import Dynamic from '@base/Dynamic/Dynamic';
import Layout from '@layout/PaymentLayout/PaymentLayout';
import PageReduxProvider from '@cont/App/PageReduxProviderWrapper';
import { fetchPostPurchaseUrls } from '@api/fetchers/goal';

const BundleSubscriptionThankyou = Dynamic(() =>
  import('@cont/Checkout/BundleSubscriptionThankyou')
);
const SubscriptionThankyou = Dynamic(() =>
  import('@cont/Checkout/SubscriptionThankyou')
);

const SubscriptionThankyouPage = ({ redirectionUrls }) => {
  const purchaseSubscriptionResponse = useSelector(
    ({ checkout }) => checkout.purchaseSubscriptionResponse
  );
  const isCombo =
    !!purchaseSubscriptionResponse?.bundle_user_subscriptions?.length;
  return isCombo ? (
    <BundleSubscriptionThankyou redirectionUrls={redirectionUrls} />
  ) : (
    <SubscriptionThankyou redirectionUrls={redirectionUrls} />
  );
};

SubscriptionThankyouPage.pageInfo = {
  isMWebSupported: true,
  name: 'Subscription Thank You',
  layoutOptions: {
    isCheckoutUrl: true,
    disableDarkMode: true,
    hideIntercom: true,
    hideFreshbot: true
  }
};

export default SubscriptionThankyouPage;

export const getStaticProps = async () => {
  try {
    const postPurchaseUrls = await fetchPostPurchaseUrls();
    const redirectionUrls = JSON.parse(postPurchaseUrls?.description);
    return {
      props: {
        redirectionUrls
      },
      revalidate: 1 * 60
    };
  } catch (err) {
    return {
      props: {},
      revalidate: 1 * 60
    };
  }
};

export const getStaticPaths = async () => {
  return {
    paths: [],
    fallback: 'blocking'
  };
};

SubscriptionThankyouPage.Layout = Layout;
SubscriptionThankyouPage.Wrapper = PageReduxProvider;
